import { createContext } from 'react';
import type { Service, ServiceType, ServiceWithChecklist } from '../types';

export interface ServicesContextType {
  service_types: ServiceType[];
  services: Service[];
  loading: boolean;
  error: string | null;
  addService: (service: Omit<ServiceWithChecklist, 'id'>) => Promise<Service>;
  updateService: (serviceId: string, serviceData: Partial<Omit<ServiceWithChecklist, 'id'>>) => Promise<Service>;
  deleteService: (serviceId: string) => Promise<void>;
  refreshServices: () => Promise<void>;
  getServiceById: (serviceId: string) => Service | undefined;
  getServiceTypes: (serviceTypeId: string) => ServiceType | undefined;
}

export const ServicesContextObject = createContext<ServicesContextType | undefined>(undefined);